/* eslint-disable */

const API_BASE_PORT = process.env.REACT_APP_API_BASE_PORT || 8443
const ACCOUNT_API_BASE_PORT = process.env.REACT_APP_ACCOUNTAPI_BASE_PORT || 8445

// Fetch backend data from the same domain (vault-dev.xion.ai/vault.xion.ai) in production
const API_BASE_URL = `https://${
    process.env.NODE_ENV === 'development' || window.location.hostname.includes("localhost")
        ? process.env.REACT_APP_API_BASE_DEVELOPMENT_URL
        : window.location.hostname
}:${API_BASE_PORT}`

const ACCOUNTAPI_BASE_URL = `https://${
    process.env.NODE_ENV === 'development' || window.location.hostname.includes("localhost")
        ? process.env.REACT_APP_API_BASE_DEVELOPMENT_URL
        : window.location.hostname
}:${ACCOUNT_API_BASE_PORT}`

const ROOT_URL_PARTS = {
    USER: API_BASE_URL + '/user',
    AUTH: API_BASE_URL + '/auth',
    MANAGE: API_BASE_URL + '/manage',
    STORE: API_BASE_URL + '/store',
    ADMIN: API_BASE_URL + '/admin',
    BILLING: API_BASE_URL + '/billing',
    SIDE_BY_SIDE: API_BASE_URL + '/sideBySide',
    GST: API_BASE_URL + '/gst',
    ACCOUNTING: API_BASE_URL + '/accounting',
    CASH_ACCOUNTING: API_BASE_URL + '/cashaccounting',
}

export class API_URLS {
    static HOSTNAME = window.location.hostname.includes("localhost")
        ? `https://${window.location.hostname}:${process.env.REACT_APP_FRONTEND_DEVELOPMENT_PORT || 3000}`
    : `https://${process.env.REACT_APP_API_BASE_PRODUCTION_URL}`
static OAUTH2_REDIRECT_URI = API_URLS.HOSTNAME + '/oauth2/redirect'
static GOOGLE_AUTH_URL = API_BASE_URL + '/oauth2/authorize/google?redirect_uri=' + API_URLS.OAUTH2_REDIRECT_URI

// const API_BASE_URL = window.location.hostname.includes("localhost") ? `https://vault-dev.xion.ai:8443` : `https://${window.location.hostname}:8443`
// const ACCOUNTAPI_BASE_URL = window.location.hostname.includes("localhost") ? `https://vault-dev.xion.ai:8445` : `https://${window.location.hostname}:8445`

static URL_BANK = 'https://bank.xion.ai'
static URL_PAYMENTS = 'https://billpay.xion.ai'
static URL_PULSE = 'https://pulse.xion.ai'
static URL_AUTH = 'https://auth.xion.ai'
static URL_WIDGETS = 'https://widgets.xion.ai'
// static URL_BANK = 'https://bank-dev.xion.ai'
// static URL_PAYMENTS = 'https://payments-dev.xion.ai'
// static URL_PULSE = 'https://pulse-dev.xion.ai'
// static URL_AUTH = 'https://auth-dev.xion.ai'
// static URL_WIDGETS = 'https://widgets-dev.xion.ai'

static FEEDBACK_URL = API_BASE_URL + "/feedback"

// Authorization
static LOGIN = ROOT_URL_PARTS.AUTH + "/login"
static LOGOUT = ROOT_URL_PARTS.AUTH + "/logout"
static SIGNUP = ROOT_URL_PARTS.AUTH + "/signup"
static RESEND_VERIFY_EMAIL = ROOT_URL_PARTS.AUTH + "/resendVerify?email=[email]"

// Manage
static FILE_TREE = ROOT_URL_PARTS.MANAGE + "/getFileTree"
static NEW_FOLDER = ROOT_URL_PARTS.MANAGE + "/newFolder"
static RENAME_FOLDER = ROOT_URL_PARTS.MANAGE + "/renameFolder"
static DELETE_FOLDER = ROOT_URL_PARTS.MANAGE + "/deleteFolder"
static DELETE_FILE = ROOT_URL_PARTS.MANAGE + "/deleteObject"
static DELETE_FILES = ROOT_URL_PARTS.MANAGE + "/deleteObjects"
static MOVE_FOLDER = ROOT_URL_PARTS.MANAGE + "/moveFolder"
static MOVE_FILE = ROOT_URL_PARTS.MANAGE + "/moveObject"
static MOVE_FILES = ROOT_URL_PARTS.MANAGE + "/moveObjects"
static TOGGLE_FLAG = ROOT_URL_PARTS.MANAGE + "/toggleFlag"
static LOAD_DATA = ROOT_URL_PARTS.MANAGE + "/loadResData"
static LOAD_DATA_PAGE = ROOT_URL_PARTS.MANAGE + "/loadResDataPage"
static FILTER_DATA = ROOT_URL_PARTS.MANAGE + "/loadResDataLabelFilter"

// Store
static UPLOAD_FILES = ROOT_URL_PARTS.STORE + "/uploadFiles"
static UPLOAD_FILE = ROOT_URL_PARTS.STORE + "/uploadFile"
static UPLOAD_CSV = ROOT_URL_PARTS.STORE + "/storeCsvData"
static DOWNLOAD_DOCUMENTS = ROOT_URL_PARTS.STORE + "/downloadFolder"
static DOWNLOAD_MULTIPLE_FILES = ROOT_URL_PARTS.STORE + "/downloadFiles"
static CHANGE_DOCUMENT_TYPE = ROOT_URL_PARTS.STORE + "/classifyOthers"
static DOCUMENT_DOWNLOAD = ROOT_URL_PARTS.STORE + "/downloadFile"

// Admin
static BANKS = ROOT_URL_PARTS.ADMIN + "/banks"
static UPDATE_COMPANY = ROOT_URL_PARTS.ADMIN + "/editCompany"
static CREATE_COMPANY = ROOT_URL_PARTS.ADMIN + "/createCompany"
static COMPANY_LIST = ROOT_URL_PARTS.ADMIN + "/listAvailableCompanies"
static UPDATED_COMPANY_LIST = ROOT_URL_PARTS.ADMIN + "/getCompanyList"
static COMPANY_BANK_MAP = ROOT_URL_PARTS.ADMIN + "/getCompanyBankMapByID"
static COMPANY_DETAILS = ROOT_URL_PARTS.ADMIN + "/getCompaniesByLegalName"
static BILLING_PLAN = ROOT_URL_PARTS.ADMIN + "/getSubscriptionByCompany?permId=[permId]"

// User
static PROFILE = ROOT_URL_PARTS.USER + "/me";
static ALL_USERS = ROOT_URL_PARTS.USER + "/listAll"
static INVITE = ROOT_URL_PARTS.USER + "/invite"
static RESET_PASSWORD = ROOT_URL_PARTS.USER + "/newPassword";
static UPDATE_USER_PROFILE = ROOT_URL_PARTS.USER + "/update";
static UPDATE_PERMISSIONS = ROOT_URL_PARTS.USER + "/grantPermission"
static FORGOT_PASSWORD = ROOT_URL_PARTS.USER + "/forgot?email=[email]"
static VERIFY_EMAIL = ROOT_URL_PARTS.USER + "/verifyEmail?token=[token]&id=[id]"
static USER_PERMISSION = ROOT_URL_PARTS.USER + "/getPermsFromEmail?email=[email]"
static COMPANY_PERMISSION = ROOT_URL_PARTS.USER + "/permForCompany?companyNames=[companyNames]"

// Side view page
static ADD_LABEL = ROOT_URL_PARTS.SIDE_BY_SIDE + "/addLabel"
static REMOVE_LABEL = ROOT_URL_PARTS.SIDE_BY_SIDE + "/removeLabel"
static GET_LABELS = ROOT_URL_PARTS.SIDE_BY_SIDE + "/labelsForCompany"
static DOCUMENT_FORM_DATA = ROOT_URL_PARTS.SIDE_BY_SIDE + "/loadForm"
static DOCUMENT_TABLE_DATA = ROOT_URL_PARTS.SIDE_BY_SIDE + "/loadTable"
static SAVE_DATA = ROOT_URL_PARTS.SIDE_BY_SIDE + "/storeResData"
static SAVE_ACTIONS = ROOT_URL_PARTS.SIDE_BY_SIDE + "/storeActions"
static GET_ACTIONS = ROOT_URL_PARTS.SIDE_BY_SIDE + "/getActions"
static DELETE_ACTIONS = ROOT_URL_PARTS.SIDE_BY_SIDE + "/deleteActions"
static GST_SUPPLIERS = ROOT_URL_PARTS.SIDE_BY_SIDE + "/suppliers"
static GST_PURCHASERS = ROOT_URL_PARTS.SIDE_BY_SIDE + "/purchasers"

// Billing
static CLIENT_DETAIL = ROOT_URL_PARTS.BILLING + "/getClientDetails";
static CURRENT_ESTIMATE = ROOT_URL_PARTS.BILLING + "/getCurrentEstimate";
static BILLING_HISTORY = ROOT_URL_PARTS.BILLING + "/getBillingHistory";
static GET_BILLING = ROOT_URL_PARTS.BILLING + "/getBillingInfo?permId=[permId]";
static GET_INVOICES = ROOT_URL_PARTS.BILLING + "/getInvoices?permId=[permId]";
static DOWNLOAD_INVOICE = ROOT_URL_PARTS.BILLING + "/getInvoiceURL";
static CREATE_CLIENT = ROOT_URL_PARTS.BILLING + "/createClient";
static SUBSCRIBE_TO_PLAN = ROOT_URL_PARTS.BILLING + "/getSessionSuccess"
static START_SESSION = ROOT_URL_PARTS.BILLING + "/startSession"
static AUTHORIZE_EXTRA_PAY = ROOT_URL_PARTS.BILLING + "/authorizeExtraPayment"

// GST Filing
static GST_IS_ACTIVE = ROOT_URL_PARTS.GST + "/isActive";
static GST_LOAD_LIST = ROOT_URL_PARTS.GST + "/loadListings";
static GST_ACTIVATE_COMPANY = ROOT_URL_PARTS.GST + "/activateCompany";
static GST_LOAD_FORM_DETAIL = ROOT_URL_PARTS.GST + "/loadForm";
static GST_LOAD_TRANSACTION = ROOT_URL_PARTS.GST + "/loadTransactions";
static GST_SUBMIT = ROOT_URL_PARTS.GST + "/submit";
static GST_LOAD_F5_PDF = ROOT_URL_PARTS.GST + "/loadF5PDF";
static GST_STORE_F5_PDF = ROOT_URL_PARTS.GST + "/storeF5PDF";
static GST_LOAD_TRANSACTION_XLSX = ROOT_URL_PARTS.GST + "/loadTransactionXlsx";
static GST_GET_SING_PASS = ROOT_URL_PARTS.GST + "/getSingPassURL";

// Accounting Service
static PUSH_DOCUMENT = ROOT_URL_PARTS.ACCOUNTING + "/pushDocument";
static GET_ACCOUNT = ROOT_URL_PARTS.ACCOUNTING + "/viewAccount";

// Accounting Software Integation
static QUICKBOOK_AUTH = ROOT_URL_PARTS.ACCOUNTING + "/auth/quickBooks";
static XERO_AUTH = ROOT_URL_PARTS.ACCOUNTING + "/auth/xero";
static GET_MARKETING_ACCOUNT = ROOT_URL_PARTS.ACCOUNTING + "/viewCompany";

// Reports
static PNL_REPORT = ROOT_URL_PARTS.ACCOUNTING + "/pnl/[legalName]?fromDate=[fromDate]&endDate=[endDate]";
static BALANCE_SHEET = ROOT_URL_PARTS.ACCOUNTING + "/balancesheet/[legalName]?fromDate=[fromDate]&endDate=[endDate]";
static CASH_FLOW = ROOT_URL_PARTS.ACCOUNTING + "/cashflow/[legalName]?fromDate=[fromDate]&endDate=[endDate]";
static SUMMERY_DROPDOWN = ROOT_URL_PARTS.ACCOUNTING + "/keymetrics/dropdown/[legalName]";
static SUMMERY = ROOT_URL_PARTS.ACCOUNTING + "/keymetrics/[legalName]?set1StartDate=[set1StartDate]&set1EndDate=[set1EndDate]&set2StartDate=[set2StartDate]&set2EndDate=[set2EndDate]";

// Cash Accounting
static CA_COMPANY_BANKS = ROOT_URL_PARTS.CASH_ACCOUNTING + "/banks/[legalName]";
static BANK_STATEMENT_LIST = ROOT_URL_PARTS.CASH_ACCOUNTING + "/list/[legalName]?status=[status]";
static UPDATE_BANK_LINE_ITEM = ROOT_URL_PARTS.CASH_ACCOUNTING + "/update/[legalName]/[status]";

static RUN_SCRIPT_SIDE_BY_SIDE = API_BASE_URL + '/owl/runSideBySide'
static RUN_SCRIPT_DASHBOARD = API_BASE_URL + '/owl/runDashboard'
}
